import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: center;
  padding-left: 71px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  @media (max-width: 1400px) {
    padding-left: 35px;
  }
`;
